import * as Q from "q";
import * as globalConfig from "globalConfig";

// Models
import { NavigationMenuResponse } from "Content/ts/Models/Shared/Navigation/MainMenu/MainMenuDetails";

export module MainNavigationMenuServices {
    export function RetrieveNavigationMenuStructure(): Q.Promise<Array<NavigationMenuResponse>> {
        return Q($.ajax({
            url: globalConfig.Urls.Navigation.RetrieveNavigationMenu,
            type: "GET"
        }));
    }
}